<template>
  <div class="painelSimulacao">
    <div class="ml-3 mt-2 mr-3">
      Painel Projeto do <strong>GT - Bichos peçonhentos</strong>

      <gantt-elastic
        :tasks="tasks"
        :options="options"
        @chart-project-click="teste"
        @chart-milestone-click="teste"
        @chart-task-click="teste"
      >
        <gantt-header :options="userOptions" slot="header"></gantt-header>
      </gantt-elastic>
    </div>
  </div>
</template>

<script>
import GanttElastic from "gantt-elastic";
import Header from "gantt-elastic-header";

const defaultOptions = {
  title: {
    label: "asdsad-elastic",
    html: false,
  },
  locale: {
    Now: "Now",
    "X-Scale": "Zoom-X",
    "Y-Scale": "Zoom-Y",
    "Task list width": "Task list",
    "Before/After": "Expand",
    "Display task list": "Show task list",
  },
};

export default {
  components: {
    "gantt-header": Header,
    "gantt-elastic": GanttElastic,
  },
  created() {
    //this.carregarProjetos();
  },
  data() {
    return {
      unwatchTasks: {},
      userOptions: {
        title: {
          label: "",
          html: true,  
          
        },
        locale: {
          Now: "Hoje",
          "X-Scale": "Escala X",
          "Y-Scale": "Escala Y",
          "Task list width": "Lista de atividades",
          "Before/After": "Expandir",
          "Display task list": "Atividades",
        },
      },
      tasks: [
        {
          id: 1,
          codigo: "PR2021-000001",
          label: "Criar Manual",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user1-128x128.jpg" title="Marcos Osorio" width="25" class="rounded-circle mr-2 mt-n1" style="border: 1px solid #C0C0C0;"><img src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg" title="Roberto de Souza" width="25" class="rounded-circle mr-2 mt-n1" style="border: 1px solid #C0C0C0; margin-left: -5px;"><img src="https://adminlte.io/themes/v3/dist/img/user6-128x128.jpg" title="Marcelo Moreira"  width="25" class="rounded-circle mr-2 mt-n1" style="border: 1px solid #C0C0C0; margin-left: -5px;"></div>',
          start: this.obterData(-24 * 2),
          inicio: this.formatarData(-24 * 2),
          fim: this.formatarData(24 * 5),
          duration: 1 * 24 * 60 * 60 * 1000,
          progress: 90,
          type: "project",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
            "chart-row-bar-polygon": {
              stroke: "#0EAC51",
              fill: "#1EBC61",
            },
            "chart-row-progress-bar-outline": {
              stroke: "#0EAC30",
            },
          },
        },
        {
          id: 2,
          codigo: "PR2021-000002",
          label: "Detalhar Manual",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user1-128x128.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Marcos Osorio</div>',
          parentId: 1,
          start: this.obterData(-24 * 1),
          inicio: this.formatarData(-24 * 1),
          fim: this.formatarData(24 * 5),
          duration: 1 * 24 * 60 * 60 * 1000,
          progress: 50,
          type: "milestone",
          dependentOn: [1],
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
            /*
                        'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },
                    }*/
          },
        },
        {
          id: 3,
          codigo: "PR2021-000003",
          label: "Criar publicidade do Ministério da Saúde",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user6-128x128.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Marcelo El-Corab</div>',
          start: this.obterData(24 * 0),
          inicio: this.formatarData(-24 * 0),
          fim: this.formatarData(24 * 5),
          duration: 2 * 24 * 60 * 60 * 1000,
          progress: 75,
          type: "task",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
          },
          /*style: {
                        'chart-row-bar' : {
                            cursor: 'pointer',
                        },
                        'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },
                    }*/
        },
        {
          id: 4,
          codigo: "PR2021-000004",
          label: "Finalizar o Manual",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user3-128x128.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Pedro Raul de Castro</div>',
          parentId: 1,
          start: this.obterData(-24 * 0),
          inicio: this.formatarData(-24 * 2),
          fim: this.formatarData(24 * 5),
          duration: 1 * 24 * 60 * 60 * 1000,
          progress: 60,
          dependentOn: [2],
          type: "project",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
            /*'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },*/
          },
        },
        {
          id: 5,
          codigo: "PR2021-000005",
          label: "Desenvolver a prática segura da saúde",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user5-128x128.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Fernando Garcia</div>',
          start: this.obterData(-24 * 2),
          inicio: this.formatarData(-24 * 2),
          fim: this.formatarData(24 * 5),
          duration: 3 * 24 * 60 * 60 * 1000,
          progress: 50,
          type: "milestone",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
            /*
                        'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },
                    }*/
          },
        },
        {
          id: 6,
          codigo: "PR2021-000006",
          label: "Vacinar os pobres e os oprimidos",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user4-128x128.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Marcelo Moreira</div>',
          start: this.obterData(24 * 1),
          inicio: this.formatarData(-24 * 0),
          fim: this.formatarData(24 * 5),
          duration: 3 * 24 * 60 * 60 * 1000,
          progress: 20,
          type: "task",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
          },
          /*style: {
                        'chart-row-bar' : {
                            cursor: 'pointer',
                        },
                        'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },
                    }*/
        },
        {
          id: 7,
          codigo: "PR2021-000007",
          label: "Criar Manual",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Roberto Souza</div>',
          start: this.obterData(-24 * 2),
          inicio: this.formatarData(-24 * 2),
          fim: this.formatarData(24 * 5),
          duration: 1 * 24 * 60 * 60 * 1000,
          progress: 60,
          type: "project",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
            "chart-row-bar-polygon": {
              stroke: "#0EAC51",
              fill: "#1EBC61",
            },
            "chart-row-progress-bar-outline": {
              stroke: "#0EAC30",
            },
          },
        },
        {
          id: 8,
          codigo: "PR2021-000008",
          label: "Detalhar Manual",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user1-128x128.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Marcos Osorio</div>',
          start: this.obterData(-24 * 1),
          inicio: this.formatarData(-24 * 1),
          fim: this.formatarData(24 * 5),
          duration: 1 * 24 * 60 * 60 * 1000,
          progress: 50,
          type: "milestone",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
            /*
                        'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },
                    }*/
          },
        },
        {
          id: 9,
          codigo: "PR2021-000009",
          label: "Criar publicidade do Ministério da Saúde",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user6-128x128.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Marcelo El-Corab</div>',
          start: this.obterData(24 * 0),
          inicio: this.formatarData(-24 * 0),
          fim: this.formatarData(24 * 5),
          duration: 2 * 24 * 60 * 60 * 1000,
          progress: 75,
          type: "task",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
          },
          /*style: {
                        'chart-row-bar' : {
                            cursor: 'pointer',
                        },
                        'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },
                    }*/
        },
        {
          id: 10,
          codigo: "PR2021-000010",
          label: "Criar Manual",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Roberto Souza</div>',
          start: this.obterData(-24 * 2),
          inicio: this.formatarData(-24 * 2),
          fim: this.formatarData(24 * 5),
          duration: 1 * 24 * 60 * 60 * 1000,
          progress: 60,
          type: "project",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            } /*
                        'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },*/,
          },
        },
        {
          id: 11,
          codigo: "PR2021-000011",
          label: "Detalhar Manual",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user1-128x128.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Marcos Osorio</div>',
          start: this.obterData(-24 * 1),
          inicio: this.formatarData(-24 * 1),
          fim: this.formatarData(24 * 5),
          duration: 1 * 24 * 60 * 60 * 1000,
          progress: 50,
          type: "milestone",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
            /*
                        'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },
                    }*/
          },
        },
        {
          id: 12,
          codigo: "PR2021-000012",
          label: "Criar publicidade do Ministério da Saúde",
          user: '<div class="mt-2"><img src="https://adminlte.io/themes/v3/dist/img/user6-128x128.jpg" alt="User Avatar" width="25" class="rounded-circle mr-2 mt-n1"><a href="/user" target="_blank">Marcelo El-Corab</div>',
          start: this.obterData(24 * 0),
          inicio: this.formatarData(-24 * 0),
          fim: this.formatarData(24 * 5),
          duration: 2 * 24 * 60 * 60 * 1000,
          progress: 75,
          type: "task",
          style: {
            "chart-row-bar": {
              cursor: "pointer",
            },
          },
          /*style: {
                        'chart-row-bar' : {
                            cursor: 'pointer',
                        },
                        'chart-row-bar-polygon' : {
                            stroke: '#0EAC51',
                            fill: '#1EBC61',
                        },
                        'chart-row-progress-bar-outline': {
                            stroke: '#0EAC30',
                        },
                    }*/
        },
      ],
      options: {
        row: {
          height: 21,
        },
        calendar: {
          hour: {
            display: false,
          },
        },
        locale: {
          //*
          name: "en",
          weekdays: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split(
            "_"
          ),
          weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sab".split("_"),
          weekdaysMin: "D_S_T_Q_Q_S_S".split("_"),
          months:
            "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
              "_"
            ),
          monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
            "_"
          ),
          weekStart: 1,
          relativeTime: {
            future: "em %s",
            past: "%s atrás",
            s: "em segundos",
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            M: "um mês",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos",
          },
          formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
          },
          ordinal: (n) => {
            const s = ["th", "st", "nd", "rd"];
            const v = n % 100;
            return `[${n}${s[(v - 20) % 10] || s[v] || s[0]}]`;
          },
        },
        title: {
          label: "Título",
          html: true,
          style: {
            "font-size": "20px",
            "vertical-align": "middle",
            "font-weight": "400",
            "line-height": "35px",
            "padding-left": "22px",
            "letter-spacing": "1px",
          },
        },
        taskList: {
          expander: {
            straight: true,
          },
          columns: [
            {
              id: 1,
              label: "Código",
              value: "codigo",
              width: 95,
              style: {
                "task-list-header-label": {
                  "font-weight": "bold",
                },
              },
              expander: false,
            },
            {
              id: 2,
              label: "Projeto",
              value: "label",
              width: 220,
              style: {
                "task-list-header-label": {
                  "font-weight": "bold",
                },
                "task-list-item-value": {
                  cursor: "pointer",
                  color: "#0077c0",
                },
              },
              events: {
                click({ data }) {
                  alert(
                    "description clicked!\n" + data.id + " - " + data.label
                  );
                },
              },
              expander: true,
            },
            {
              id: 3,
              label: "Responsável",
              value: "user",
              width: 110,
              style: {
                "task-list-header-label": {
                  "font-weight": "bold",
                },
              },
              html: true,
            },
            {
              id: 3,
              label: "Início",
              value: "inicio",
              width: 72,
              style: {
                "task-list-header-label": {
                  "font-weight": "bold",
                  "text-align": "center",
                },
              },
            },
            {
              id: 4,
              label: "Fim",
              value: "fim",
              width: 72,
              style: {
                "task-list-header-label": {
                  "font-weight": "bold",
                  "text-align": "center",
                },
              },
            } /*, {
                            id: 4,
                            label: 'Type',
                            value: 'type',
                            width: 68
                        }*/,
            {
              id: 5,
              label: "%",
              value: "progress",
              width: 35,
              style: {
                "task-list-header-label": {
                  "font-weight": "bold",
                  "text-align": "center",
                },
                "task-list-item-value-container": {
                  "text-align": "center",
                  width: "100%",
                },
              },
            },
          ],
        },
      },
    };
  },
  methods: {
    carregarProjetos() {
      this.$clubApi
        .get("/projeto/painel")
        .then((response) => {
          this.listaProjeto = response.data.object;
        })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = false;
        });
    },
    obterData(horas) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;
      const currentDay = currentDate.getDate();
      const timeStamp = new Date(
        `${currentYear}-${currentMonth}-${currentDay} 00:00:00`
      ).getTime();
      return new Date(timeStamp + horas * 60 * 60 * 1000);
    },
    formatarData(horas) {
      let dataVar = this.obterData(horas);
      return (
        dataVar.getDate().toString().padStart(2, "0") +
        "/" +
        (dataVar.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        dataVar.getFullYear()
      );
    },
    teste(options) {
      alert(options.data.id + " - " + options.data.label);
    },
  },
};
</script>
